import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom';
import { isLogin } from '../constants/sessionHelper';
import { getFromStorage } from '../Hooks/useLocalStorage';
// import { AuthContext } from '../context/Auth';

function PrivateRoute({ children, ...rest }) {
    // let auth = useContext(AuthContext);
    return (
        <Route
            {...rest}
            render={({ location }) =>
               isLogin()? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}

export default PrivateRoute;